var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-list-create","width":400,"toptitle":_vm.project.title,"title":"Verteiler erstellen"}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-list-form',{attrs:{"projectList":_vm.projectList,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }